<template>
  <div class="app-inner">
    <div class="searchTitleDiv">
      <div class="stateDiv">
        <p class="searchText">楼宇</p>
        <el-select v-model="buildingId" placeholder="请选择楼宇名称" clearable>
          <el-option
              v-for="item in buildingValueList"
              :key="item.buildingId"
              :label="item.buildingName"
              :value="item.buildingId">
          </el-option>
        </el-select>
      </div>
      <el-button class="searchBtn btn1" type="primary" @click="getData">查 询</el-button>
<!--      <el-button class="searchBtn btn2" type="warning" @click="uploadFun">导入</el-button>-->
      <el-button class="searchBtn btn2" type="warning" @click="exportFun">导出</el-button>
      <el-button class="searchBtn btn3" type="warning" @click="printFun()">打印</el-button>
    </div>
    <!--      列表-->
    <div class="table" id="printContract">
      <div class="searchList">
        <el-table
            v-loading="loading"
            :data="tableData"
            :default-sort = "{prop: 'id', order: 'descending'}"
            style="width: 100%"
            :highlight-current-row="false"
            :header-cell-style="{background:'#F4F7FA',color:'#606266'}">
          <el-table-column
              label="序号"
              type="index"
              :index="typeIndex"
              width="90">
          </el-table-column>
          <template v-for="(item, index) in tableColumns">
            <el-table-column
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :formatter="item.formatter"
                :width="item.width">
            </el-table-column>
          </template>
<!--          <el-table-column label="操作" width="130">-->
<!--            <template slot-scope="scope" class="tableButton">-->
<!--              <el-button class="tableBtn" @click="viewOrHandle(scope.row)" type="text" size="small">编辑</el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
      </div>
      <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalCount"
          class="paginationBody">
      </el-pagination>
    </div>
    <!--    新增/编辑弹框-->
    <div class="dialogDiv">
      <el-dialog
          :title="eventControl"
          :visible.sync="dialogFormVisible"
          :before-close="closeAdd"
          center
      >
        <el-form ref="addForm" :model="addForm" :rules="rules" class="formDiv">
          <el-form-item label="租赁单位名称" label-width="1.8rem" prop="companyName" class="formItem">
            <el-input v-model="addForm.companyName" auto-complete="off" disabled></el-input>
          </el-form-item>
          <el-form-item label="室号" label-width="1.8rem" prop="roomNumber" class="formItem">
            <el-input v-model="addForm.roomNumber" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="面积" label-width="1.8rem" prop="area" class="formItem">
            <el-input v-model="addForm.area"></el-input>
          </el-form-item>
          <el-form-item label="单价" label-width="1.8rem" prop="unitPrice" class="formItem">
            <el-input v-model="addForm.unitPrice"></el-input>
          </el-form-item>
          <el-form-item label="年租金" label-width="1.8rem" prop="annualRental" class="formItem">
            <el-input v-model="addForm.annualRental"></el-input>
          </el-form-item>
          <el-form-item label="付款方式" label-width="1.8rem" prop="paymentMode" class="formItem">
            <el-input v-model="addForm.paymentMode"></el-input>
          </el-form-item>
          <el-form-item label="本期租金日" label-width="1.8rem" prop="rentDate" class="formItem">
            <el-input v-model="addForm.rentDate"></el-input>
          </el-form-item>
          <el-form-item label="租金到位率" label-width="1.8rem" prop="rentalPaidRate" class="formItem">
            <el-input v-model="addForm.rentalPaidRate"></el-input>
          </el-form-item>
          <el-form-item label="保证金" label-width="1.8rem" prop="deposit" class="formItem">
            <el-input v-model="addForm.deposit"></el-input>
          </el-form-item>
          <el-form-item label="合同期" label-width="1.8rem" prop="contractPeriod" class="formItem">
            <el-input v-model="addForm.contractPeriod"></el-input>
          </el-form-item>
          <el-form-item label="税收落地" label-width="1.8rem" prop="landingTax" class="formItem">
            <el-input v-model="addForm.landingTax"></el-input>
          </el-form-item>
          <el-form-item label="备注" label-width="1.8rem" class="formItemRemark" >
            <el-input type="textarea" v-model="addForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeAdd">取 消</el-button>
          <el-button type="primary" @click="addEventForm()">保 存</el-button>
        </div>
      </el-dialog>
    </div>
    <!--    导入弹框-->
    <div class="dialogUploadDiv">
      <el-dialog title="导入楼宇出租房屋租金收缴统计表" :visible.sync="uploadDialogVisible" center>
        <el-upload
            class="upload-demo"
            ref="uploadFile"
            action=""
            :auto-upload="false"
            :http-request="httpRequest"
            :on-change="handleChange"
            :on-remove="handleRemove"
            :file-list="fileList"
            show-file-list
            accept=".xls, .xlsx"
        >
          <el-button style="width: 1.5rem"><i class="el-icon-upload2"></i>上传文件</el-button>
        </el-upload>
        <div class="imgAndText">
          <p>限Excel文件(后缀名为.xls或.xlsx),不超过10000条且文件大小控制在2M内</p>
          <div class="uploadRule">
            <p class="titleS">导入说明</p>
            <p>1.导入的文件格式为Excel格式，后缀名为.xls或.xlsx;</p>
            <p>2.导入的文件应放在文件的第一个工作表中;</p>
            <p>3.请勿修改导出表格的标题（第一行）;</p>
            <p>4.请务必填写表格中必填信息;</p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="searchBtn" type="primary" @click="importFun()">提交</el-button>
          <el-button class="searchBtn searchBtn2" @click="uploadDialogVisible = false">取消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { listBuildingInfos } from '@/api/searchList'
import { queryExcelBuidingRental, updateExcelBuidingRental,
  importExcelBuidingRental, exportContractStatistics } from '@/api/statistics'
export default {
  name: 'buildingRent',
  data () {
    return {
      printObj: {
        id: 'printContract',
        popTitle: '打印',
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>,<style> #printContract { width: inherit !important; } </style>'
      },
      loading: false,
      yearValue: '',
      stateValue: '',
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      dialogFormVisible: false,
      eventControl: '',
      pageList: [],
      assignPageList: [],
      uploadDialogVisible: false,
      fileList: [],
      buildingId: '',
      buildingValueList: [],
      addForm: {
        buildingId: '',
        buildingName: '',
        companyName: '',
        roomNumber: '',
        area: '',
        unitPrice: '',
        annualRental: '',
        paymentMode: '',
        rentDate: '',
        rentalPaidRate: '',
        deposit: '',
        contractPeriod: '',
        landingTax: '',
        remark: '',
        id: ''
      },
      rules: {
        roomNumber: [{ required: true, message: '请填写', trigger: 'blur' }],
        area: [{ required: true, message: '请填写', trigger: 'blur' }],
        unitPrice: [{ required: true, message: '请填写', trigger: 'blur' }],
        annualRental: [{ required: true, message: '请填写', trigger: 'blur' }],
        paymentMode: [{ required: true, message: '请填写', trigger: 'blur' }],
        rentDate: [{ required: true, message: '请填写', trigger: 'blur' }],
        rentalPaidRate: [{ required: true, message: '请填写', trigger: 'blur' }],
        deposit: [{ required: true, message: '请填写', trigger: 'blur' }],
        contractPeriod: [{ required: true, message: '请填写', trigger: 'blur' }],
        landingTax: [{ required: true, message: '请填写', trigger: 'blur' }],
        remark: [{ required: true, message: '请填写', trigger: 'blur' }]
      },
      tableData: [],
      tableColumns: [
        {
          prop: 'companyName',
          label: '租赁单位名称'
        },
        {
          prop: 'buildingName',
          label: '楼宇名称'
        },
        {
          prop: 'roomNumber',
          label: '室号'
        },
        {
          prop: 'contractRentalArea',
          label: '面积'
        },
        {
          prop: 'daliyRental',
          label: '日租金'
        },
        // {
        //   prop: 'annualRental',
        //   label: '年租金'
        // },
        // {
        //   prop: 'rentalPayCycle',
        //   label: '付款周期'
        // },
        // {
        //   prop: 'securityDeposit',
        //   label: '保证金'
        // },
        // {
        //   prop: 'contractPeriod',
        //   label: '合同期'
        // },
        {
          prop: 'contractEndDate',
          label: '合同到期日'
        },
        // {
        //   prop: 'remark',
        //   label: '备注'
        // }
      ]
    }
  },
  mounted () {
    this.getData()
    this.getBuildingList()
  },
  methods: {
    // 所属楼宇下拉框
    async getBuildingList () {
      let res = await listBuildingInfos({})
      if (res.code === 0) {
        this.buildingValueList = res.result
      }
    },
    // 处理表格序号，序号递增
    typeIndex (index) {
      let vm = this // 处理分页数据的 index
      return (vm.currentPage - 1) * vm.pageSize + index + 1
    },
    getData () {
      this.currentPage = 1
      this.queryList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryList()
    },
    // 查询
    async queryList () {
      let res = await queryExcelBuidingRental({
        buildingId: this.buildingId,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === 0) {
        this.tableData = res.result.records
        this.totalCount = res.result.total
      }
    },
    viewOrHandle (row) {
      this.dialogFormVisible = true
      this.eventControl = '编辑汇总表'
      this.addForm = row
    },
    closeAdd () {
      this.dialogFormVisible = false
      this.$refs['addForm'].resetFields()
      // this.getData()
    },
    addEventForm () {
      this.$refs['addForm'].validate(async (valid) => {
        if (valid) {
          let res = await updateExcelBuidingRental({
            buildingId: this.addForm.buildingId,
            buildingName: this.addForm.buildingName,
            companyName: this.addForm.companyName,
            roomNumber: this.addForm.roomNumber,
            area: this.addForm.area,
            unitPrice: this.addForm.unitPrice,
            annualRental: this.addForm.annualRental,
            paymentMode: this.addForm.paymentMode,
            rentDate: this.addForm.rentDate,
            rentalPaidRate: this.addForm.rentalPaidRate,
            deposit: this.addForm.deposit,
            contractPeriod: this.addForm.contractPeriod,
            landingTax: this.addForm.landingTax,
            remark: this.addForm.remark,
            id: this.addForm.id
          })
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '保存成功'
            })
            this.dialogFormVisible = false
            this.$refs['addForm'].resetFields()
            this.getData()
          } else {
            this.$message({
              type: 'warning',
              message: res.message
            })
          }
        }
      })
    },
    uploadFun () {
      this.uploadDialogVisible = true
    },
    // 导入
    async httpRequest (param) {
      let file = param.file
      let fd = new FormData()
      fd.append('multipartFile ', file)
      let res = await importExcelBuidingRental(fd)
      if (res.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        await this.getData()
        this.fileList = []
        this.isFileSelected = false
        this.uploadDialogVisible = false
      } else {
        this.$message.error(res.message)
      }
    },
    handleChange (file, fileList) {
      // fileList = fileList.slice(-1)
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      if (file && fileList.length) {
        this.isFileSelected = true
      }
    },
    handleRemove  (file, fileList) {
      if (!fileList.length) {
        this.isFileSelected = false
      }
    },
    // 上传文件，提交审核
    importFun () {
      if (this.isFileSelected) {
        this.$refs.uploadFile.submit()
      } else {
        this.$message.error('请选择文件！')
      }
    },
    // 导出
    async exportFun () {
      let res = await exportContractStatistics({
        buildingId: this.buildingId
      })
      const elink = document.createElement('a')
      elink.download = '楼宇出租房屋租金收缴统计表.xls'
      elink.style.display = 'none'
      const blob = new Blob([res])
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      document.body.removeChild(elink)
    },
    // 打印时跳转页面
    printFun () {
      this.$router.push({
        path: '/report/printBuildingRent',
        query: {
          buildingId: this.buildingId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .app-inner {
    width: 98%;
    height: 70vh;
    padding: 0.2rem;
    box-sizing: border-box;
  }
  .searchTitleDiv {
    width: 15rem;
    height: 0.66rem;
    margin-left: 0.2rem;
    margin-top: 0.05rem;

    .stateDiv {
      margin-top: 0.14rem;
      float: left;
    }

    .searchText {
      margin-top: 0.05rem;
      margin-right: 0.13rem;
      font-size: 0.2rem;
      color: #111111;
      float: left;
    }

    .inputDiv {
      width: 2.2rem;
      float: left;
    }

    .searchBtn {
      /*width: 1.20rem;*/
      /*height: 0.36rem;*/
      /*border-radius: 0.06rem;*/
      /*font-size: 0.18rem;*/
      margin-top: 0.14rem;
      /*padding-top: 0.1rem;*/
    }
    .btn1{
      margin-left: .5rem;
    }
    .btn2{
      position: absolute;
      right: 3.3rem;
    }
    .btn3{
      position: absolute;
      right: 2rem;
    }
  }
  .table{
    margin-top: .3rem;
    margin-left: .5rem;
    text-align: center;
    width: 14.5rem;
    .searchList{
    }
    .paginationBody{
      margin-top: .1rem;
    }
  }
  .formDiv{
    .formItem{
      display: inline-block;
      width: 3.9rem;
      float: left;
      margin-left: .3rem;
    }
    .formItemRemark{
      display: inline-block;
      width: 3.9rem;
      margin-left: .3rem;
    }
  }
  .dialogDiv{
    /deep/ .el-dialog{
      width: 50%!important;
    }
  }
  .dialogUploadDiv{
    .imgAndText{
      p{
        margin-top: .2rem;
      }
      .titleS{
        font-size: .16rem;
        color: #1989fa;
      }
      .downloadTemp{
        width: 1.5rem;
        padding-left: .2rem;
        color: #1989fa;
        cursor: pointer;
        text-decoration:underline;
      }
    }
    /deep/ .el-dialog{
      width: 35%!important;
    }
  }
</style>
